<template>
  <section id="checkout" class="checkout-section">
    <div class="container">
      <img style="width:800px;" src="@/assets/img/blog/zs1.png" />
    </div>
  </section>
</template>
<script>
export default {
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex; align-items: center; justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/home/certificate.vue